import {__} from "./__";

export const getPermissions = () => {
    return {
        'orders': { name: __('Objednávky'), value: true },
        'orders-view': { name: __('Objednávky - zobrazenie detailu'), value: true },
        'orders-changestate': { name: __('Objednávky - zmena stavu'), value: true },
        'orders-sync': { name: __('Objednávky - synchronizácia'), value: true },
        'orders-pdf': { name: __('Objednávky - stiahnutie pdf'), value: true },
        'orders-paid': { name: __('Objednávky - uhradenie'), value: true },
        'orders-send': { name: __('Objednávky - odoslanie'), value: true },
        'orders-email': { name: __('Objednávky - email'), value: true },
        'orders-delete': { name: __('Objednávky - zmazanie'), value: true },
        'clients': { name: __('Zákaznici'), value: true },
        'clients-comment': { name: __('Zákaznici - nastavenie internej poznámky'), value: true },
        'clients-delete': { name: __('Zákaznici - zmazanie'), value: true },
        'products': { name: __('Produkty'), value: true },
        'products-view': { name: __('Produkty - zobrazenie detailu'), value: true },
        'products-delete': { name: __('Produkty - zmazanie'), value: true },
        'invoices': { name: __('Faktúry'), value: true },
        'invoices-create': { name: __('Faktúry - vystavenie'), value: true },
        'invoices-pdf': { name: __('Faktúry - stiahnutie pdf'), value: true },
        'invoices-delete': { name: __('Faktúry - zmazanie'), value: true },
        'payments': { name: __('Platby'), value: true },
        'payments-delete': { name: __('Platby - zmazanie'), value: true },
        'labels': { name: __('Štítky'), value: true },
        'labels-pdf': { name: __('Štítky - stiahnutie pdf'), value: true },
        'labels-delete': { name: __('Štítky - zmazanie'), value: true },
        'bmails': { name: __('Bankové pohyby'), value: false },
        'exports': { name: __('Exporty'), value: true },
        'exports-edit': { name: __('Exporty - úprava'), value: true },
        'exports-delete': { name: __('Exporty - zmazanie'), value: true },
        'templates': { name: __('Emaily'), value: true },
        'templates-edit': { name: __('Emaily - úprava'), value: true },
        'templates-delete': { name: __('Emaily - zmazanie'), value: true },
        'templates-smtp': { name: __('Emaily - nastavenie smtp'), value: true },
        'notifications': { name: __('Notifikácie'), value: true },
        'subscription': { name: __('Členstvo'), value: true },
        'marketplaces': { name: __('Trhoviská'), value: true },
        'track_trace': { name: __('Track & Trace'), value: true },
        'complaints': { name: __('Reklamácie'), value: true },
        'complaints-edit': { name: __('Reklamácie - úprava'), value: true },
        'complaints-send': { name: __('Reklamácie - odoslanie'), value: true },
        'complaints-delete': { name: __('Reklamácie - zmazanie'), value: true },
        'settings': { name: __('Nastavenia'), value: true },
        'settings-eshop': { name: __('Nastavenia - eshop'), value: true },
        'settings-accounting': { name: __('Nastavenia - ekonomický systém'), value: true },
        'settings-couriers': { name: __('Nastavenia - prepravcovia'), value: true },
        'settings-storage': { name: __('Nastavenia - sklad'), value: true },
        'settings-bank': { name: __('Nastavenia - banka'), value: true },
        'points': { name: __('Mapy'), value: true },
        'points-create': { name: __('Mapy - vytvorenie'), value: true },
        'points-edit': { name: __('Mapy - editácia'), value: true },
        'points-delete': { name: __('Mapy - zmazanie'), value: true },
        'files': { name: __('Úložisko'), value: true },
        'files-upload': { name: __('Úložisko - vytvorenie'), value: true },
        'files-download': { name: __('Úložisko - stiahnutie'), value: true },
        'files-delete': { name: __('Úložisko - zmazanie'), value: true },
        'aifunctions': { name: __('AI funkcie'), value: true },
        'aifunctions-create': { name: __('AI funkcie - vytvorenie'), value: true },
        'aifunctions-run': { name: __('AI funkcie - spustenie'), value: true },
        'aifunctions-edit': { name: __('AI funkcie - editácia'), value: true },
        'aifunctions-delete': { name: __('AI funkcie - zmazanie'), value: true },
        'aicommands': { name: __('AI úlohy'), value: true },
        'aiaddons': { name: __('AI doplnky'), value: false },
        'aiagents': { name: __('AI agenti'), value: false },
        'categories': { name: __('Kategórie'), value: true },
        'categories-view': { name: __('Kategórie - zobrazenie detailu'), value: true },
        'categories-delete': { name: __('Kategórie - zmazanie'), value: true },
    };
};
